import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { motion } from 'framer-motion';
import ImgHoverEffect from '../ui/ImgHoverEffect';

// Images
import HeroDishImg from "../../images/hero-dish.png";

// Animation variants
const container = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.3,
        },
    },
};

const item = {
    hidden: { y: 20, opacity: 0 },
    show: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 100,
        }
    },
};


export default function HeroSection() {


    return (
        <>
            <section className='hero-section' id='home'>
                <Container>
                    <Row className='align-items-center'>
                        <Col md={6} xl={6} xxl={5}>
                            <div className="hero-section-main-content mb-5 mb-md-0 text-center text-md-start">
                                <motion.div variants={container} initial="hidden" animate="show" className="hero-content">
                                    <motion.span variants={item} className='badge bg-soft-danger badge-lg mb-3 d-inline-block'>
                                        <i className="ri-restaurant-fill me-1"></i> Best Healthy Food
                                    </motion.span>

                                    <motion.h1 variants={item} className='hero-title display-2 fw-semibold text-shadow mb-0'>
                                        Enjoy <motion.span className='text-danger d-inline-block' whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}>Delicious</motion.span> Food in Your Healthy Life
                                    </motion.h1>

                                    <motion.p variants={item} className='text-muted my-4 fs-20 me-xl-5'>
                                        This is a type of restaurant which typically serves food and drink, in addition to light refreshments such as baked goods.
                                    </motion.p>

                                    <motion.div variants={item} className='d-flex flex-wrap gap-3 justify-content-center justify-content-md-start pt-4'>
                                        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                                            <Button type="button" className="btn btn-danger" size='lg'>Get Started</Button>
                                        </motion.div>
                                        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                                            <Button type="button" className="btn btn-dark" size='lg'>Order Now</Button>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            </div>
                        </Col>
                        <Col md={6} className='offset-xxl-1'>
                            <motion.div initial="initial" animate="animate" variants={item} className="d-inline-block">
                                <ImgHoverEffect className="d-inline-block" intensity={20} scale={1.05}>
                                    <Image src={HeroDishImg} alt="" className='img-fluid about-img-shadow img-hover' />
                                </ImgHoverEffect>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
